import script from "./StandardizedLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardizedLocation.vue?vue&type=script&setup=true&lang=js"

import "./StandardizedLocation.vue?vue&type=style&index=0&id=365759ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-365759ba"]])

export default __exports__